/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDirectUpload200ResponseDirectUpload
 */
export interface CreateDirectUpload200ResponseDirectUpload {
    /**
     * 
     * @type {string}
     * @memberof CreateDirectUpload200ResponseDirectUpload
     */
    url: string;
    /**
     * 
     * @type {object}
     * @memberof CreateDirectUpload200ResponseDirectUpload
     */
    headers: object;
}

/**
 * Check if a given object implements the CreateDirectUpload200ResponseDirectUpload interface.
 */
export function instanceOfCreateDirectUpload200ResponseDirectUpload(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "url" in value;
    isInstance = isInstance && "headers" in value;

    return isInstance;
}

export function CreateDirectUpload200ResponseDirectUploadFromJSON(json: any): CreateDirectUpload200ResponseDirectUpload {
    return CreateDirectUpload200ResponseDirectUploadFromJSONTyped(json, false);
}

export function CreateDirectUpload200ResponseDirectUploadFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDirectUpload200ResponseDirectUpload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
        'headers': json['headers'],
    };
}

export function CreateDirectUpload200ResponseDirectUploadToJSON(value?: CreateDirectUpload200ResponseDirectUpload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
        'headers': value.headers,
    };
}

